import {
  createSlice,
  createAsyncThunk,
} from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { publicHttpService } from "../../../services/publicHttpService";

interface CoreState {
  loading?: boolean;
  data?: any;
  error?: boolean;
  errorMessage?: string;
  success?: boolean;
}

const initialState: CoreState = {
  loading: false,
  data: "",
  error: false,
  errorMessage: "",
  success: false,
};

// export const checkLogin = createAsyncThunk(
//   "login/checkLogin",
//   async (cred: any) => {
//     try {
//       const responseData: any = await publicHttpService.post(
//         "vendors/login",
//         cred,
//       );

//       if (responseData.code == 200) {
//         toast.success(
//           "You’ve successfully logged in. Redirecting to your dashboard...",
//           {
//             position: "top-center",
//             autoClose: 20,
//           },
//         );
//         localStorage.setItem("us_st_d", responseData.data.token);
//         return responseData.data;
//       }
//     } catch (error: any) {
//       console.log("errrr-------", error);
//       toast.error(error.message, { position: "top-center" });

//       return false;
//     }
//   },
// );


export const checkLogin = createAsyncThunk(
  "login/checkLogin",
  async (cred: any, { rejectWithValue }) => {
    try {
      const responseData: any = await publicHttpService.post(
        "vendors/login",
        cred,
      );

      // Check if response is successful (status 200)
      if (responseData.code === 200) {
        if(responseData?.data?.token){
          localStorage.setItem("us_st_d", responseData.data.token);
          return responseData.data;
        }
        else {
          // No token in response
          return rejectWithValue({
            message: responseData.message || "Login failed. Please try again.",
            code: responseData.code
          });
        }
      } else {
        // For non-200 responses, the error message should be in the response
        // Based on your backend, it could be:
        // - "This phone number is not associated with any account. Check or register a new account."
        // - "Incorrect phone number or password. Try again."
        return rejectWithValue({
          message: responseData.message || "Login failed. Please try again.",
          code: responseData.code
        });
      }
    } catch (error: any) {
      console.log("Login error:", error);

      // Extract correct API error message from the error response
      let apiErrorMessage = "Something went wrong, please try again.";
      
      if (error?.response?.data) {
        // The API error response structure based on your backend
        const errorData = error.response.data;
        
        // Check for different error message locations
        if (errorData.message) {
          apiErrorMessage = errorData.message;
        } else if (errorData.error && Array.isArray(errorData.error) && errorData.error[0]) {
          apiErrorMessage = errorData.error[0];
        } else if (typeof errorData === 'string') {
          apiErrorMessage = errorData;
        }
      } else if (error.message) {
        apiErrorMessage = error.message;
      }

      return rejectWithValue({
        message: apiErrorMessage,
        status: error?.response?.status || 500
      });
    }
  },
);

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    resetLoginState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = false;
      state.errorMessage = "";
      state.data = "";
    }
  },
  extraReducers: (builder) => {
    builder.addCase(checkLogin.pending, (state) => {
      state.loading = true;
      state.success = false;
      state.error = false;
      state.errorMessage = "";
      state.data = "";
    });
    
    builder.addCase(checkLogin.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.error = false;
      state.errorMessage = "";
      state.data = action.payload;
      
      // Show success toast
      toast.success(
        "You’ve successfully logged in. Redirecting to your dashboard...",
        {
          position: "top-center",
          autoClose: 2000,
        }
      );
    });
    
    builder.addCase(checkLogin.rejected, (state, action: any) => {
      state.loading = false;
      state.success = false;
      state.error = true;
      state.errorMessage = action.payload?.message || "Login failed. Please try again.";
      state.data = "";
      
      // Show error toast with the specific message from the API
      toast.error(state.errorMessage, { 
        position: "top-center",
        autoClose: 5000 
      });
    });
  },
});

export const { resetLoginState } = loginSlice.actions;
export default loginSlice.reducer;